module.exports = __webpack_public_path__ + "media/images/wealthbar/2fa/authenticator-icon-active-fd83c6613a48676e6a9f28a96f5455d8.svg";